import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  headerData: BehaviorSubject<string> = new BehaviorSubject<string>("25");
  headerDataEsc: BehaviorSubject<string> = new BehaviorSubject<string>("allorders");
  headerDataRefund: BehaviorSubject<Number> = new BehaviorSubject<Number>(1);
  headerSelectedRefund: BehaviorSubject<Number> = new BehaviorSubject<Number>(1);
  requestFrom: BehaviorSubject<string> = new BehaviorSubject<string>("");
  sessionId: BehaviorSubject<string> = new BehaviorSubject<string>("");
  actionById: BehaviorSubject<string> = new BehaviorSubject<string>("");
  actionByName: BehaviorSubject<string> = new BehaviorSubject<string>("");
  role: BehaviorSubject<string> = new BehaviorSubject<string>("");
  portal: BehaviorSubject<string> = new BehaviorSubject<string>("");
  headerSelectedStatus: BehaviorSubject<Number> = new BehaviorSubject<Number>(25);
  headerSelectedEscStatus: BehaviorSubject<string> = new BehaviorSubject<string>("allorders");
  hideHeaderData = new BehaviorSubject<boolean>(true);
  constructor() { }

  setHideHeader(value: boolean) {
    this.hideHeaderData.next(value);
  }

  changeHeaderSelectedStatusValue(message:Number) {
    this.headerSelectedStatus.next(message)
  }
  changeValue(message: string) {
    this.requestFrom.next(message)
  }

  changeSessionId(sessionId: string) {
    this.sessionId.next(sessionId)
  }

  getActionById(){
    return this.actionById.asObservable();
  }
  getStringDate(date) {

    let month, day, year;
    month = '' + (date.getMonth() + 1),
    day = '' + date.getDate(),
    year = date.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return ([year, month, day].join('-'));

  };

  updateRoleValue(message: string) {
    this.role.next(message)
  }

  updatePortalValue(message: string) {
    this.portal.next(message)
  }
}
